
import { commonApi, common } from '@/common/index';
import { mapState, mapActions, mapMutations } from 'vuex';
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { toStarString } from '@/common/utils/index.js'
export default {
name: 'withdrawal',
components: { Confirm, Group, XSwitch, XButton },
directives: {
TransferDom
},
data() {
return {
confirm: {
show: false,
content: '',
path: ''
},
bankData: []
}
},
computed: {
...mapState({
UUID: state => state.UUID,
userInfo: state => state.userInfo.userInfo
}),
bankList() {
let list = []
if (this.bankData.length > 0 && this.$store.state.linkList.staticDomain !== '') {
this.bankData.forEach((item) => {
list.push({ ...item, picUrl: `${this.$store.state.linkList.staticDomain}/banks/${item.bankCode}.png`, banknums: toStarString(item.bankNumber) })
})
}
return list
}
},
methods: {
...mapActions(['setPicLink']),
handgoWithdrawal({ id, bankName, personname, bankCode, banknums, userBankId, picUrl }) {


if (this.$store.state.linkList.isWithdrawPassword === '1') {
if (!this.userInfo.withdrawPasswordValid) {
this.confirm.content = this.$t('ValidTips').noDrawPwd
this.confirm.path = '/My/AccountManat/WithdrawPasword'
this.confirm.show = true
return
}
}
this.$router.push({ path: '/My/Withdrawal/bankDetail', query: { id, bankName, personname, bankCode, banknums, userBankId, picUrl } })
},
handgoAddCard() {

if (this.$store.state.linkList.withdrawMethod === '0') {
if (this.userInfo.mobileValid && this.userInfo.withdrawPasswordValid) {
this.$router.push({ path: '/My/Withdrawal/addbankcard' })
} else {
if (!this.userInfo.mobileValid && !this.userInfo.withdrawPasswordValid) {
this.confirm.content = this.$t('ValidTips').noPhoneDrawPwd
this.confirm.path = '/My/AccountManat'
} else {
if (!this.userInfo.mobileValid) {
this.confirm.content = this.$t('ValidTips').noPhone
this.confirm.path = '/My/AccountManat/mobileAuth'
} else if (!this.userInfo.withdrawPasswordValid) {
this.confirm.content = this.$t('ValidTips').noDrawPwd
this.confirm.path = '/My/AccountManat/WithdrawPasword'
}
}
this.confirm.show = true
}
} else if (this.$store.state.linkList.withdrawMethod === '2') {
if (this.userInfo.withdrawPasswordValid && this.userInfo.mobilePhone) {
this.$router.push({ path: '/My/Withdrawal/addbankcard' })
} else {
if (!this.userInfo.withdrawPasswordValid && !this.userInfo.mobilePhone) {
this.confirm.content = this.$t('ValidTips').noPhoneDrawPwd2
this.confirm.path = '/My/AccountManat'
} else {
if (!this.userInfo.withdrawPasswordValid) {
this.confirm.content = this.$t('ValidTips').noDrawPwd
this.confirm.path = '/My/AccountManat/WithdrawPasword'
}
if (!this.userInfo.mobilePhone) {
this.confirm.content = this.$t('ValidTips').noPhone
this.confirm.path = '/My/AccountManat/mobileAuth'
}
}
this.confirm.show = true
}
} else {
this.$router.push({ path: '/My/Withdrawal/addbankcard' })
}
},
onConfirm() {
this.$router.push({ path: this.confirm.path })
}
},
created() {
commonApi.PAY.bankCardList().then((data) => {
this.bankData = data || []
})
},
deactivated() {

}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Withdrawal/withdrawal.vue